import { OTA_VehRentalCore } from "./ota_vehrentalcore.model";
import { OTA_DriverType } from "./ota_drivertype.model";
import { OTA_RateQualifier } from "./ota_ratequalifier.model";
import { OTA_RateRange } from "./ota_raterange.model";
import { OTA_VehPref } from "./ota_vehpref.model";
import { OTA_SpecialEquipPref } from "./ota_specialequippref.model";

export class OTA_VehAvailRQCore {
    public vehRentalCore = new OTA_VehRentalCore();
    public driverType = new OTA_DriverType();
    public rateQualifier = new OTA_RateQualifier();
    public rateRange = new OTA_RateRange();
    public vehPrefs = new Array<OTA_VehPref>();
    public specialEquipPrefs = new Array<OTA_SpecialEquipPref>();
}
